// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ControlOverride, ControlOverrideT, verifyControlOverride } from "./control-override";
import { EntryOverride, EntryOverrideT, verifyEntryOverride } from "./entry-override";
import { EventOverride, EventOverrideT, verifyEventOverride } from "./event-override";
import { Template, TemplateT, verifyTemplate } from "./template";

/**
 * Normalized overrides: sorted by key, one per key, empty fields dropped.
 */
export class MappingOverrides implements flatbuffers.IUnpackableObject<MappingOverridesT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MappingOverrides {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMappingOverrides(
    bb: flatbuffers.ByteBuffer,
    obj?: MappingOverrides,
  ): MappingOverrides {
    return (obj || new MappingOverrides()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMappingOverrides(
    bb: flatbuffers.ByteBuffer,
    obj?: MappingOverrides,
  ): MappingOverrides {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MappingOverrides()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static bufferHasIdentifier(bb: flatbuffers.ByteBuffer): boolean {
    return bb.__has_identifier("MCEO");
  }

  templates(index: number, obj?: Template): Template | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Template()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  templatesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  entries(index: number, obj?: EntryOverride): EntryOverride | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new EntryOverride()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  entriesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  events(index: number, obj?: EventOverride): EventOverride | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new EventOverride()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  eventsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  controls(index: number, obj?: ControlOverride): ControlOverride | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new ControlOverride()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  controlsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startMappingOverrides(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addTemplates(builder: flatbuffers.Builder, templatesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, templatesOffset, 0);
  }

  static createTemplatesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startTemplatesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addEntries(builder: flatbuffers.Builder, entriesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, entriesOffset, 0);
  }

  static createEntriesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startEntriesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addEvents(builder: flatbuffers.Builder, eventsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, eventsOffset, 0);
  }

  static createEventsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startEventsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addControls(builder: flatbuffers.Builder, controlsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, controlsOffset, 0);
  }

  static createControlsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startControlsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endMappingOverrides(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static finishMappingOverridesBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset, "MCEO");
  }

  static finishSizePrefixedMappingOverridesBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset, "MCEO", true);
  }

  static createMappingOverrides(
    builder: flatbuffers.Builder,
    templatesOffset: flatbuffers.Offset,
    entriesOffset: flatbuffers.Offset,
    eventsOffset: flatbuffers.Offset,
    controlsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    MappingOverrides.startMappingOverrides(builder);
    MappingOverrides.addTemplates(builder, templatesOffset);
    MappingOverrides.addEntries(builder, entriesOffset);
    MappingOverrides.addEvents(builder, eventsOffset);
    MappingOverrides.addControls(builder, controlsOffset);
    return MappingOverrides.endMappingOverrides(builder);
  }

  unpack(): MappingOverridesT {
    return new MappingOverridesT(
      this.bb!.createObjList<Template, TemplateT>(
        this.templates.bind(this),
        this.templatesLength(),
      ),
      this.bb!.createObjList<EntryOverride, EntryOverrideT>(
        this.entries.bind(this),
        this.entriesLength(),
      ),
      this.bb!.createObjList<EventOverride, EventOverrideT>(
        this.events.bind(this),
        this.eventsLength(),
      ),
      this.bb!.createObjList<ControlOverride, ControlOverrideT>(
        this.controls.bind(this),
        this.controlsLength(),
      ),
    );
  }

  unpackTo(_o: MappingOverridesT): void {
    _o.templates = this.bb!.createObjList<Template, TemplateT>(
      this.templates.bind(this),
      this.templatesLength(),
    );
    _o.entries = this.bb!.createObjList<EntryOverride, EntryOverrideT>(
      this.entries.bind(this),
      this.entriesLength(),
    );
    _o.events = this.bb!.createObjList<EventOverride, EventOverrideT>(
      this.events.bind(this),
      this.eventsLength(),
    );
    _o.controls = this.bb!.createObjList<ControlOverride, ControlOverrideT>(
      this.controls.bind(this),
      this.controlsLength(),
    );
  }

  unpackFields(...fields: string[]): MappingOverridesT {
    const t = new MappingOverridesT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("templates")) {
      t.templates = this.bb!.createObjList<Template, TemplateT>(
        this.templates.bind(this),
        this.templatesLength(),
      );
    }
    if (fieldSet.has("entries")) {
      t.entries = this.bb!.createObjList<EntryOverride, EntryOverrideT>(
        this.entries.bind(this),
        this.entriesLength(),
      );
    }
    if (fieldSet.has("events")) {
      t.events = this.bb!.createObjList<EventOverride, EventOverrideT>(
        this.events.bind(this),
        this.eventsLength(),
      );
    }
    if (fieldSet.has("controls")) {
      t.controls = this.bb!.createObjList<ControlOverride, ControlOverrideT>(
        this.controls.bind(this),
        this.controlsLength(),
      );
    }
    return t;
  }
}

export class MappingOverridesT implements flatbuffers.IGeneratedObject {
  constructor(
    public templates: TemplateT[] = [],
    public entries: EntryOverrideT[] = [],
    public events: EventOverrideT[] = [],
    public controls: ControlOverrideT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const templates = MappingOverrides.createTemplatesVector(
      builder,
      builder.createObjectOffsetList(this.templates),
    );
    const entries = MappingOverrides.createEntriesVector(
      builder,
      builder.createObjectOffsetList(this.entries),
    );
    const events = MappingOverrides.createEventsVector(
      builder,
      builder.createObjectOffsetList(this.events),
    );
    const controls = MappingOverrides.createControlsVector(
      builder,
      builder.createObjectOffsetList(this.controls),
    );

    return MappingOverrides.createMappingOverrides(builder, templates, entries, events, controls);
  }

  clone(): MappingOverridesT {
    const obj = new MappingOverridesT();
    obj.templates = this.templates.map((e) => e.clone());
    obj.entries = this.entries.map((e) => e.clone());
    obj.events = this.events.map((e) => e.clone());
    obj.controls = this.controls.map((e) => e.clone());
    return obj;
  }

  equals(other: MappingOverridesT): boolean {
    if (this.templates.length !== other.templates.length) return false;
    for (let i = 0; i < this.templates.length; i++) {
      const a = this.templates[i];
      const b = other.templates[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.entries.length !== other.entries.length) return false;
    for (let i = 0; i < this.entries.length; i++) {
      const a = this.entries[i];
      const b = other.entries[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.events.length !== other.events.length) return false;
    for (let i = 0; i < this.events.length; i++) {
      const a = this.events[i];
      const b = other.events[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.controls.length !== other.controls.length) return false;
    for (let i = 0; i < this.controls.length; i++) {
      const a = this.controls[i];
      const b = other.controls[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyMappingOverrides(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyTemplate);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyEntryOverride);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyEventOverride);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyControlOverride);
      }
    }
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsMappingOverrides(
  buf: DataView,
  opts?: flatbuffers.VerifierOptions,
): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyMappingOverrides(verifier, tablePos);
}
